export class Tutorial {
    _id;
    name: string;
    description: string;
    htmlText: string;
    sourceType: string;
    sourcePath: string;
    category: string;
    new: boolean;
    pinToTop: boolean;
    previewImagePath: string;
    active: boolean;
    deleted: boolean;
    created_by: any;
    createdAt: any;

    // For filters
    dateCreatedRange: any; 
    dateCreated;
    dateCreatedEnd;
}